// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.repeat-options[data-v-035653c9] {
  display: flex;
  flex-direction: column;
  margin-bottom: -8px;
}
.repeat-options .main-select[data-v-035653c9] {
  display: flex;
  flex-direction: row;
  align-items: baseline;
}
.repeat-options .main-select span[data-v-035653c9] {
  margin-right: 10px;
  padding-left: 26px;
  color: var(--placeholder-color);
}
.repeat-options .element[data-v-035653c9] {
  margin-bottom: 12px;
}
.repeat-options .element[data-v-035653c9] .input {
  width: 32px;
  height: 30px;
  padding-bottom: 10px !important;
}
.repeat-options .element span[data-v-035653c9] {
  color: var(--placeholder-color);
  margin: 0 6px;
}
.repeat-options .repeats[data-v-035653c9] {
  display: flex;
  align-self: flex-start;
  padding-left: 20px;
}
.repeat-options .repeat-option[data-v-035653c9] {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  margin-bottom: -10px;
}
.repeat-options .repeat-first-option .input[data-v-035653c9] {
  margin: 0 4px;
}
.repeat-options .repeat-second-option[data-v-035653c9] {
  margin-bottom: -20px;
}
.repeat-options .repeat-second-option .weekdays[data-v-035653c9] {
  display: flex;
  flex-direction: column;
  margin-left: 12px;
}
.repeat-options .repeat-second-option .weekdays .first-row[data-v-035653c9],
.repeat-options .repeat-second-option .weekdays .second-row[data-v-035653c9] {
  display: flex;
  flex-direction: row;
}
.repeat-options .repeat-second-option .weekdays .first-row[data-v-035653c9] {
  margin-top: 2px;
}
.repeat-options .repeat-second-option .weekdays .ccb[data-v-035653c9] label.custom-checkbox {
  color: var(--font-color);
  margin-right: 19px;
}
.repeat-options .repeat-second-option .weekdays .ccb[data-v-035653c9].disabled label.custom-checkbox {
  cursor: initial;
  color: var(--placeholder-color);
}
.repeat-options .repeat-fourth-option[data-v-035653c9] {
  display: flex;
  align-items: flex-start;
}
.repeat-options .repeat-fourth-option .var-elements[data-v-035653c9] {
  align-self: flex-start;
}
.repeat-options .repeat-fourth-option .var-elements span[data-v-035653c9] {
  margin-left: 04px;
  margin-right: 4px;
}
.repeat-options .repeat-fourth-option .var-elements .custom-dropdown[data-v-035653c9] {
  width: 114px;
  margin-left: 4px;
}
.repeat-options .repeat-fourth-option .var-elements .custom-dropdown.weekday[data-v-035653c9] {
  width: 66px;
}
.repeat-options .repeat-fifth-option[data-v-035653c9] {
  display: flex;
}
.repeat-options .repeat-fifth-option .input[data-v-035653c9] {
  margin-right: 8px;
}
.repeat-options .repeat-fifth-option .custom-dropdown[data-v-035653c9] {
  width: 120px;
}
.repeat-options .repeat-sixth-option[data-v-035653c9] {
  display: flex;
}
.repeat-options .repeat-sixth-option .var-elements[data-v-035653c9] {
  align-self: flex-start;
}
.repeat-options .repeat-sixth-option .var-elements span[data-v-035653c9] {
  margin-left: 3px;
  margin-right: 8px;
}
.repeat-options .repeat-sixth-option .var-elements .day-index[data-v-035653c9] {
  width: 120px;
  margin-right: 12px;
}
.repeat-options .repeat-sixth-option .var-elements .day-index[data-v-035653c9] .items {
  overflow-y: auto;
  max-height: 202px;
}
.repeat-options .month[data-v-035653c9] {
  height: 29px;
  width: 120px;
  margin: 0 10px;
}
.repeat-options .month[data-v-035653c9] .items {
  overflow-y: auto;
  max-height: 226px;
}
.repeat-options .weekday[data-v-035653c9] {
  height: 29px;
  width: 70px;
  margin: 0 -4px;
}
.repeat-options .weekday[data-v-035653c9] .items {
  overflow-y: auto;
  max-height: 226px;
}
.repeat-options .var-elements[data-v-035653c9] {
  display: flex;
  flex-direction: row;
  align-self: center;
  padding-left: 2px;
}
.custom-dropdown[data-v-035653c9] {
  width: 264px;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/modal/integrations/RepeatOptions.vue"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;AACjC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;AACA;EACE,+BAA+B;EAC/B,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;AACA;;EAEE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,YAAY;AACd","sourcesContent":[".repeat-options[data-v-035653c9] {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: -8px;\n}\n.repeat-options .main-select[data-v-035653c9] {\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n}\n.repeat-options .main-select span[data-v-035653c9] {\n  margin-right: 10px;\n  padding-left: 26px;\n  color: var(--placeholder-color);\n}\n.repeat-options .element[data-v-035653c9] {\n  margin-bottom: 12px;\n}\n.repeat-options .element[data-v-035653c9] .input {\n  width: 32px;\n  height: 30px;\n  padding-bottom: 10px !important;\n}\n.repeat-options .element span[data-v-035653c9] {\n  color: var(--placeholder-color);\n  margin: 0 6px;\n}\n.repeat-options .repeats[data-v-035653c9] {\n  display: flex;\n  align-self: flex-start;\n  padding-left: 20px;\n}\n.repeat-options .repeat-option[data-v-035653c9] {\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n  margin-bottom: -10px;\n}\n.repeat-options .repeat-first-option .input[data-v-035653c9] {\n  margin: 0 4px;\n}\n.repeat-options .repeat-second-option[data-v-035653c9] {\n  margin-bottom: -20px;\n}\n.repeat-options .repeat-second-option .weekdays[data-v-035653c9] {\n  display: flex;\n  flex-direction: column;\n  margin-left: 12px;\n}\n.repeat-options .repeat-second-option .weekdays .first-row[data-v-035653c9],\n.repeat-options .repeat-second-option .weekdays .second-row[data-v-035653c9] {\n  display: flex;\n  flex-direction: row;\n}\n.repeat-options .repeat-second-option .weekdays .first-row[data-v-035653c9] {\n  margin-top: 2px;\n}\n.repeat-options .repeat-second-option .weekdays .ccb[data-v-035653c9] label.custom-checkbox {\n  color: var(--font-color);\n  margin-right: 19px;\n}\n.repeat-options .repeat-second-option .weekdays .ccb[data-v-035653c9].disabled label.custom-checkbox {\n  cursor: initial;\n  color: var(--placeholder-color);\n}\n.repeat-options .repeat-fourth-option[data-v-035653c9] {\n  display: flex;\n  align-items: flex-start;\n}\n.repeat-options .repeat-fourth-option .var-elements[data-v-035653c9] {\n  align-self: flex-start;\n}\n.repeat-options .repeat-fourth-option .var-elements span[data-v-035653c9] {\n  margin-left: 04px;\n  margin-right: 4px;\n}\n.repeat-options .repeat-fourth-option .var-elements .custom-dropdown[data-v-035653c9] {\n  width: 114px;\n  margin-left: 4px;\n}\n.repeat-options .repeat-fourth-option .var-elements .custom-dropdown.weekday[data-v-035653c9] {\n  width: 66px;\n}\n.repeat-options .repeat-fifth-option[data-v-035653c9] {\n  display: flex;\n}\n.repeat-options .repeat-fifth-option .input[data-v-035653c9] {\n  margin-right: 8px;\n}\n.repeat-options .repeat-fifth-option .custom-dropdown[data-v-035653c9] {\n  width: 120px;\n}\n.repeat-options .repeat-sixth-option[data-v-035653c9] {\n  display: flex;\n}\n.repeat-options .repeat-sixth-option .var-elements[data-v-035653c9] {\n  align-self: flex-start;\n}\n.repeat-options .repeat-sixth-option .var-elements span[data-v-035653c9] {\n  margin-left: 3px;\n  margin-right: 8px;\n}\n.repeat-options .repeat-sixth-option .var-elements .day-index[data-v-035653c9] {\n  width: 120px;\n  margin-right: 12px;\n}\n.repeat-options .repeat-sixth-option .var-elements .day-index[data-v-035653c9] .items {\n  overflow-y: auto;\n  max-height: 202px;\n}\n.repeat-options .month[data-v-035653c9] {\n  height: 29px;\n  width: 120px;\n  margin: 0 10px;\n}\n.repeat-options .month[data-v-035653c9] .items {\n  overflow-y: auto;\n  max-height: 226px;\n}\n.repeat-options .weekday[data-v-035653c9] {\n  height: 29px;\n  width: 70px;\n  margin: 0 -4px;\n}\n.repeat-options .weekday[data-v-035653c9] .items {\n  overflow-y: auto;\n  max-height: 226px;\n}\n.repeat-options .var-elements[data-v-035653c9] {\n  display: flex;\n  flex-direction: row;\n  align-self: center;\n  padding-left: 2px;\n}\n.custom-dropdown[data-v-035653c9] {\n  width: 264px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
